import axios from "axios";
import * as DAOUtils from "../utils/DAOUtils";

export function getBackendVersion() {
  return DAOUtils.get("/backendversion");
}

export function getFrontendJenkinsVersion() {
  return axios.get("/version.jenkins.json");
}

export function getFrontendDevopsVersion() {
  return axios.get("/version.devops.json");
}
